import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
//import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/es/storage/session'
import rootReducer from '../reducers';
export default function configureStore(initialState) {

    const persistConfig = { key: 'root', storage: storageSession };
    const persistedReducer = persistReducer(persistConfig, rootReducer)

    let store = createStore(persistedReducer, initialState, applyMiddleware(thunk));
    let persistor = persistStore(store)

    return { store, persistor }
}